<template>
  <div>
    <h1>Templates</h1>
    <v-btn :to="{ name: 'templateAdd' }"> <v-icon>add</v-icon>Template </v-btn>
    <v-btn
      :to="{ name: 'templates', params: { archived: false } }"
      v-if="$route.params.archived"
      >Archived</v-btn
    >
    <v-btn
      :to="{ name: 'templates', params: { archived: true } }"
      v-if="!$route.params.archived"
      >Live</v-btn
    >
    <v-btn @click="updateVisibility()" v-if="$keycloak.hasRealmRole('root')"
      >Update visibility</v-btn
    >
    <v-card>
      <v-card-title v-if="modifiedTemplates">
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          outline
        />
      </v-card-title>
      <v-data-table
        :pagination.sync="pagination"
        :headers="headers"
        :items="modifiedTemplates"
        v-if="modifiedTemplates"
        class="elevation-1"
        :search="search"
      >
        <template v-slot:items="props">
          <tr>
            <td>
              <img
                :alt="props.item.image"
                :src="require(`@/assets/events/${props.item.image}`)"
                aspect-ratio="1"
              />
            </td>
            <td>
              <router-link
                :to="{ name: 'template', params: { id: props.item.id } }"
                >{{ props.item.code }}</router-link
              >
            </td>
            <td>{{ props.item.name }}</td>
            <td>
              <v-chip
                small
                v-for="department in props.item.departments"
                :key="department.id"
                >{{ department.name }}</v-chip
              >
            </td>
            <td>
              <v-chip
                small
                v-for="category in props.item.categories"
                :key="category.id"
                >{{ category.shortname }}</v-chip
              >
            </td>
            <td>
              <v-chip small v-for="type in props.item.types" :key="type.id">{{
                type.name
              }}</v-chip>
            </td>
            <td>
              <v-chip small v-for="role in props.item.roles" :key="role.id">{{
                role.name
              }}</v-chip>
              <span class="templatesRowHidden" v-if="props.item.system"
                >System</span
              >
              <!-- <span v-if="props.item.system">&#160;|&#160;</span>
              <span class="templatesRowHidden" v-if="props.item.hide"
                >Hidden on tracker</span
              >
              <span class="templatesRowVisible" v-if="!props.item.hide"
                >Visible on tracker</span
              > -->
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Templates",
  metaInfo() {
    return {
      title: "Templates",
      titleTemplate: "%s - Document - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  computed: {
    modifiedTemplates() {
      if (!this.templates) {
        return undefined;
      }
      return this.templates.map((t) => {
        const categories =
          this.categories && this.categories[t.id]
            ? this.categories[t.id]
            : undefined;
        const departments =
          this.departments && this.departments[t.id]
            ? this.departments[t.id]
            : undefined;
        const types =
          this.types && this.types[t.id] ? this.types[t.id] : undefined;
        const roles =
          this.roles && this.roles[t.id] ? this.roles[t.id] : undefined;
        return { ...t, categories, departments, types, roles };
      });
    }
  },
  data() {
    return {
      templates: null,
      categories: null,
      departments: null,
      types: null,
      roles: null,
      search: "",
      headers: [
        {
          text: "Image",
          value: "id"
        },
        {
          text: "Code",
          value: "code"
        },
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Departments",
          sortable: false
        },
        {
          text: "Categories",
          sortable: false
        },
        {
          text: "Entity types",
          sortable: false
        },
        {
          text: "Visible to",
          sortable: false
        }
      ],
      pagination: {
        rowsPerPage: 25,
        sortBy: "code",
        descending: false
      }
    };
  },
  methods: {
    async fetchTemplates() {
      const response = await nbmlaw.get(
        `/cors/admin/document/templates/archived/${this.$route.params.archived}`
      );
      // console.log(response.data);
      this.templates = response.data;
    },
    async fetchTemplatesCategories() {
      const response = await nbmlaw.get(
        `/cors/admin/document/templates/all/categories`
      );
      // console.log(response.data);
      this.categories = response.data;
    },
    async fetchTemplatesDepartments() {
      const response = await nbmlaw.get(
        `/cors/admin/document/templates/all/departments`
      );
      // console.log(response.data);
      this.departments = response.data;
    },
    async fetchTemplatesTypes() {
      const response = await nbmlaw.get(
        `/cors/admin/document/templates/all/types`
      );
      // console.log(response.data);
      this.types = response.data;
    },
    async fetchTemplatesRoles() {
      const response = await nbmlaw.get(
        `/cors/admin/document/templates/all/roles`
      );
      // console.log(response.data);
      this.roles = response.data;
    },
    async updateVisibility() {
      if (confirm("Are you sure?")) {
        await nbmlaw.post(`/cors/admin/document/templates/all/roles`);
        this.fetchAll();
      }
    },
    fetchAll() {
      this.fetchTemplates();
      this.fetchTemplatesCategories();
      this.fetchTemplatesDepartments();
      this.fetchTemplatesTypes();
      this.fetchTemplatesRoles();
    }
  },
  watch: {
    "$route.params.archived": {
      immediate: true,
      handler() {
        this.fetchAll();
      }
    }
  }
};
</script>
